import { IACDLEvent } from '../../../../../../__legacy__/services/eventBus.service';

export const ImportAnnotationsFailureResponseEventType = Symbol('IMPORT_ANNOTATION_FAILURE_RESPONSE_EVENT');

export class ImportAnnotationsFailureResponseEvent implements IACDLEvent {
  constructor(public readonly errorCodes: string[]) {}

  readonly type: symbol = ImportAnnotationsFailureResponseEventType;
}
